// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/img/ArrowDown.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DodajNastupnoPredavanjeModal_modalOverlay__wZkrF {
  position: fixed;
  top: 0;
  left: 15%;
  width: 85%;
  height: 100%;
  background-color: #000000d6;
  z-index: 100;
}
.DodajNastupnoPredavanjeModal_modalOverlay__wZkrF,
.DodajNastupnoPredavanjeModal_tableWrapper__fG9ll {
  display: flex;
  align-items: center;
  justify-content: center;
}
.DodajNastupnoPredavanjeModal_infoModal__PJ\\+Od {
  flex-direction: column;
  width: 80%;
  padding: 24px 0px 24px 0px;
}
.DodajNastupnoPredavanjeModal_exitBtn__xLBFs {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.DodajNastupnoPredavanjeModal_title__k-Uhu {
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.DodajNastupnoPredavanjeModal_infoModal__PJ\\+Od {
  justify-content: center;
  gap: 24px;
}
.DodajNastupnoPredavanjeModal_infoModal__PJ\\+Od,
.DodajNastupnoPredavanjeModal_btnRow__ryLRw,
.DodajNastupnoPredavanjeModal_modalWrapper__36Gdf {
  display: flex;
  align-items: center;
}
.DodajNastupnoPredavanjeModal_btnRow__ryLRw {
  justify-content: flex-end;
  gap: 24px;
  width: 100%;
  margin-top: 48px;
  margin-bottom: 32px;
}
.DodajNastupnoPredavanjeModal_modalWrapper__36Gdf {
  justify-content: flex-start;
  flex-direction: column;
  width: 55%;
  border-radius: 16px;
  border: 1px solid #d1d9e2;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #ffffff;
}
.DodajNastupnoPredavanjeModal_inputWrapper__gg74h {
  width: 100%;
  gap: 16px;
  margin-top: 24px;
}
.DodajNastupnoPredavanjeModal_inputWrapper__gg74h,
.DodajNastupnoPredavanjeModal_inputColumn__aYG6t {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
}
.DodajNastupnoPredavanjeModal_inputColumn__aYG6t {
  width: 98%;
}
.DodajNastupnoPredavanjeModal_label__GYCbM {
  text-align: left;
  color: #5f6d7e;
}
.DodajNastupnoPredavanjeModal_divider__7zPe8 {
  width: 100%;
  height: 1px;
  background-color: #d8dbdf;
  margin-bottom: 12px;
}
.DodajNastupnoPredavanjeModal_modalInput__l2nog {
  width: 100%;
}
.DodajNastupnoPredavanjeModal_modalInput__l2nog,
.DodajNastupnoPredavanjeModal_modalSelect__\\+Ymm4 {
  padding: 8px;
  border: 1px solid #d8dbdf;
  border-radius: 8px;
  text-align: left;
  color: #5f6d7e;
  box-shadow: 4px 4px 64px 0px #5f6d7e1a;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.001em;
}
.DodajNastupnoPredavanjeModal_modalSelect__\\+Ymm4 {
  height: 40px;
  width: 103%;
  background-color: white;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: 97%;
  background-position-y: center;
  background-repeat: no-repeat;
}
.DodajNastupnoPredavanjeModal_cancelBtn__iKuo7,
.DodajNastupnoPredavanjeModal_successBtn__XfykN {
  width: 30%;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;

  cursor: pointer;
  height: 52px;
}
.DodajNastupnoPredavanjeModal_cancelBtn__iKuo7,
.DodajNastupnoPredavanjeModal_successBtn__XfykN,
.DodajNastupnoPredavanjeModal_label__GYCbM {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.016px;
}

.DodajNastupnoPredavanjeModal_successBtn__XfykN {
  background: #cb9c2d;
  color: #fff;
}
.DodajNastupnoPredavanjeModal_successBtn__XfykN:hover {
  background-color: #9b7725;
}
.DodajNastupnoPredavanjeModal_cancelBtn__iKuo7 {
  background-color: #ebebeb;
  color: #808080;
}
.DodajNastupnoPredavanjeModal_cancelBtn__iKuo7:hover {
  background-color: #a09f9f;
  color: #fff;
}
.DodajNastupnoPredavanjeModal_error__L204j {
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #cb2d2d;
}

@media screen and (max-width: 1300px) {
  .DodajNastupnoPredavanjeModal_modalOverlay__wZkrF {
    width: 100%;
    left: 0;
  }
}

@media screen and (max-width: 725px) {
  .DodajNastupnoPredavanjeModal_modalOverlay__wZkrF {
    justify-content: center;
    align-items: flex-end;
  }
  .DodajNastupnoPredavanjeModal_modalWrapper__36Gdf {
    width: 100%;
    border-radius: 16px 16px 0 0;
  }
  .DodajNastupnoPredavanjeModal_btnRow__ryLRw {
    justify-content: center;
  }
  .DodajNastupnoPredavanjeModal_exitBtn__xLBFs {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .DodajNastupnoPredavanjeModal_cancelBtn__iKuo7,
  .DodajNastupnoPredavanjeModal_successBtn__XfykN {
    width: 50%;
  }
  .DodajNastupnoPredavanjeModal_title__k-Uhu {
    font-size: 26px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/NastupnoPredavanjeTable/Modal/DodajNastupnoPredavanjeModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;AACA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,yDAA8D;EAC9D,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;;EAEE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;;EAElB,eAAe;EACf,YAAY;AACd;AACA;;;EAGE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,4BAA4B;EAC9B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 15%;\n  width: 85%;\n  height: 100%;\n  background-color: #000000d6;\n  z-index: 100;\n}\n.modalOverlay,\n.tableWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.infoModal {\n  flex-direction: column;\n  width: 80%;\n  padding: 24px 0px 24px 0px;\n}\n.exitBtn {\n  position: absolute;\n  top: 5%;\n  right: 3%;\n  cursor: pointer;\n}\n.title {\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.infoModal {\n  justify-content: center;\n  gap: 24px;\n}\n.infoModal,\n.btnRow,\n.modalWrapper {\n  display: flex;\n  align-items: center;\n}\n.btnRow {\n  justify-content: flex-end;\n  gap: 24px;\n  width: 100%;\n  margin-top: 48px;\n  margin-bottom: 32px;\n}\n.modalWrapper {\n  justify-content: flex-start;\n  flex-direction: column;\n  width: 55%;\n  border-radius: 16px;\n  border: 1px solid #d1d9e2;\n  box-shadow: 0px 1px 2px 0px #1018280d;\n  background-color: #ffffff;\n}\n.inputWrapper {\n  width: 100%;\n  gap: 16px;\n  margin-top: 24px;\n}\n.inputWrapper,\n.inputColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n}\n.inputColumn {\n  width: 98%;\n}\n.label {\n  text-align: left;\n  color: #5f6d7e;\n}\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: #d8dbdf;\n  margin-bottom: 12px;\n}\n.modalInput {\n  width: 100%;\n}\n.modalInput,\n.modalSelect {\n  padding: 8px;\n  border: 1px solid #d8dbdf;\n  border-radius: 8px;\n  text-align: left;\n  color: #5f6d7e;\n  box-shadow: 4px 4px 64px 0px #5f6d7e1a;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  letter-spacing: -0.001em;\n}\n.modalSelect {\n  height: 40px;\n  width: 103%;\n  background-color: white;\n  appearance: none;\n  background-image: url(../../../../../assets/img/ArrowDown.png);\n  background-position-x: 97%;\n  background-position-y: center;\n  background-repeat: no-repeat;\n}\n.cancelBtn,\n.successBtn {\n  width: 30%;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n\n  cursor: pointer;\n  height: 52px;\n}\n.cancelBtn,\n.successBtn,\n.label {\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.016px;\n}\n\n.successBtn {\n  background: #cb9c2d;\n  color: #fff;\n}\n.successBtn:hover {\n  background-color: #9b7725;\n}\n.cancelBtn {\n  background-color: #ebebeb;\n  color: #808080;\n}\n.cancelBtn:hover {\n  background-color: #a09f9f;\n  color: #fff;\n}\n.error {\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #cb2d2d;\n}\n\n@media screen and (max-width: 1300px) {\n  .modalOverlay {\n    width: 100%;\n    left: 0;\n  }\n}\n\n@media screen and (max-width: 725px) {\n  .modalOverlay {\n    justify-content: center;\n    align-items: flex-end;\n  }\n  .modalWrapper {\n    width: 100%;\n    border-radius: 16px 16px 0 0;\n  }\n  .btnRow {\n    justify-content: center;\n  }\n  .exitBtn {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .cancelBtn,\n  .successBtn {\n    width: 50%;\n  }\n  .title {\n    font-size: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `DodajNastupnoPredavanjeModal_modalOverlay__wZkrF`,
	"tableWrapper": `DodajNastupnoPredavanjeModal_tableWrapper__fG9ll`,
	"infoModal": `DodajNastupnoPredavanjeModal_infoModal__PJ+Od`,
	"exitBtn": `DodajNastupnoPredavanjeModal_exitBtn__xLBFs`,
	"title": `DodajNastupnoPredavanjeModal_title__k-Uhu`,
	"btnRow": `DodajNastupnoPredavanjeModal_btnRow__ryLRw`,
	"modalWrapper": `DodajNastupnoPredavanjeModal_modalWrapper__36Gdf`,
	"inputWrapper": `DodajNastupnoPredavanjeModal_inputWrapper__gg74h`,
	"inputColumn": `DodajNastupnoPredavanjeModal_inputColumn__aYG6t`,
	"label": `DodajNastupnoPredavanjeModal_label__GYCbM`,
	"divider": `DodajNastupnoPredavanjeModal_divider__7zPe8`,
	"modalInput": `DodajNastupnoPredavanjeModal_modalInput__l2nog`,
	"modalSelect": `DodajNastupnoPredavanjeModal_modalSelect__+Ymm4`,
	"cancelBtn": `DodajNastupnoPredavanjeModal_cancelBtn__iKuo7`,
	"successBtn": `DodajNastupnoPredavanjeModal_successBtn__XfykN`,
	"error": `DodajNastupnoPredavanjeModal_error__L204j`
};
export default ___CSS_LOADER_EXPORT___;
